import { useState } from 'react'
import { SidebarSort } from 'components/sidebar/components/folders/tree'
import { loadFoldersFirst, loadSort, saveFoldersFirst, saveSort } from 'components/sidebar/components/folders/viewState'

export interface SidebarSortState {
  sort: SidebarSort
  /** Sorts the sidebar for this viewer, and remembers it for this hub. */
  setSort: (sort: SidebarSort) => void
  /** Each level lists its folders before its documents and tables, each group in the sort's order. */
  foldersFirst: boolean
  /** Turns folders first on or off for this viewer, and remembers it for this hub. */
  setFoldersFirst: (foldersFirst: boolean) => void
}

const load = (hubId: string) => ({ hubId, sort: loadSort(hubId), foldersFirst: loadFoldersFirst(hubId) })

/**
 * The viewer's own sort for the hub's sidebar, and whether it lists folders first, remembered per hub in
 * localStorage and read again on switching hub. Unlike the open folders they need nothing from the hub
 * to be read.
 */
export const useSidebarSort = (hubId: string): SidebarSortState => {
  const [state, setState] = useState(() => load(hubId))
  // Another hub: its own sort, read before this render is shown.
  if (state.hubId !== hubId) setState(load(hubId))
  const setSort = (sort: SidebarSort): void => {
    setState((current) => ({ ...current, sort }))
    saveSort(hubId, sort)
  }
  const setFoldersFirst = (foldersFirst: boolean): void => {
    setState((current) => ({ ...current, foldersFirst }))
    saveFoldersFirst(hubId, foldersFirst)
  }
  return { sort: state.sort, setSort, foldersFirst: state.foldersFirst, setFoldersFirst }
}
